var generic = generic || {};
var site = site || {};

site.quickshop = site.quickshop || {};
site.sellsWith = site.sellsWith || {};

var mixAndMatch = function (context) {
  this.init(context);
};

mixAndMatch.prototype = {
  nodes: [],
  moduleImageFolder: '',
  offerProducts: [],
  offerCriteriaProducts: [],
  optionProducts: [],
  baseProducts: [],
  moduleSkus: [],
  getDom: function (context) {
    var self = this;

    self.nodes.$formatter = $('.js-mix-and-match--formatter', context);
    self.nodes.$itemWrapper = $('.mix-and-match--item--wrapper', self.nodes.$formatter);
    self.nodes.$baseItemsContainer = $('.js-mix-and-match--item-base--wrapper', self.nodes.$formatter);
    self.nodes.$baseItems = $('.js-mix-and-match--item-base', self.nodes.$formatter);
    self.nodes.$baseFinalItemsChange = $('.js-mix-and-match--item--final--base--change', self.nodes.$formatter);
    self.nodes.$optionItemsContainer = $('.js-mix-and-match--item-option--wrapper', self.nodes.$formatter);
    self.nodes.$optionItems = $('.js-mix-and-match--item-option', self.nodes.$formatter);
    self.nodes.$optionFinalItemsChange = $('.js-mix-and-match--item--final--option--change', self.nodes.$formatter);
    self.nodes.$itemsImages = $('.js-mix-and-match--item--image--container .mix-and-match--item--image', self.nodes.$formatter);
    self.nodes.$itemTitle = $('.js-mix-and-match--item--title', self.nodes.$formatter);
    self.nodes.$itemTitleGridView = $('.js-mix-and-match--item--title--grid-view', self.nodes.$formatter);
    self.nodes.$finalItem = $('.mix-and-match--item--wrapper--final', self.nodes.$formatter);
    self.nodes.$finalImage = $('.js-mix-and-match--item--image-final', self.nodes.$finalItem);
    self.nodes.$finalTitle = $('.js-mix-and-match--item--final--title', self.nodes.$finalItem);
    self.nodes.$finalDetailsContainer = $('.js-mix-and-match--item-final--details--wrapper', self.nodes.$finalItem);
    self.nodes.$finalItemPriceContainer = $('.js-mix-and-match--item--final--price', self.nodes.$finalItem);
    self.nodes.$finalItemContainer = $('.mix-and-match--item--container', self.nodes.$finalItem);
    self.nodes.$addToBagButton = $('.js-mix-and-match-cta', self.nodes.$formatter);
    self.nodes.$learnMore = $('.js-mix-and-match-cta-learn-more', self.nodes.$formatter);
    self.nodes.$slider = $('.js-mix-and-match--slider', self.nodes.$formatter);
    self.nodes.$stepSliders = $('.js-mix-and-match--step--slider', self.nodes.$slider);
    self.nodes.$stepSliderBase = $('.js-mix-and-match--step--slider', self.nodes.$baseItemsContainer);
    self.nodes.$stepSliderOption = $('.js-mix-and-match--step--slider', self.nodes.$optionItemsContainer);
    self.nodes.$slickDotsContainer = $('.js-mix-and-match--slider--dots', self.nodes.$formatter);
    self.nodes.$slickDotsContainerSteps = $('.js-mix-and-match--slider--dots', self.nodes.$itemWrapper);
    self.nodes.$slickDots = $('.js-mix-and-match--slider--icon', self.nodes.$slickDotsContainer);
    self.nodes.$selectButtons = $('.js-mix-and-match--select--btn', self.nodes.$formatter);
    self.nodes.$detailsButtons = $('.js-mix-and-match--item--details--btn', self.nodes.$formatter);
    self.nodes.$detailsContainers = $('.js-mix-and-match--item--details--wrapper', self.nodes.$formatter);
    self.nodes.$detailsCloseButtons = $('.js-mix-and-match--item--details--close-btn', self.nodes.$detailsContainers);
    self.nodes.$detailsText = $('.js-mix-and-match--item--details--text--grid-view', self.nodes.$formatter);
    self.nodes.$productImages = site.client.isMobile ? $('.js-mix-and-match--item--image-small', self.nodes.$formatter) : $('.js-mix-and-match--item--image', self.nodes.$formatter);
    self.nodes.$productImages.attr('src', self.nodes.$productImages.data('src')).removeClass('.hidden');
    self.nodes.$productImagesContainers = $('.js-mix-and-match--item--image--container', self.nodes.$formatter);
    self.nodes.$baseChoiceContainer = $('.mix-and-match--item--final--choices--base', self.nodes.$formatter);
    self.nodes.$optionChoiceContainer = $('.mix-and-match--item--final--choices--option', self.nodes.$formatter);
    self.nodes.$finalRadioSection = $('.mix-and-match--item--radio', self.nodes.$formatter);
    self.nodes.$changeMobile = $('.js-mix-and-match-mobile-change', self.nodes.$formatter);
    self.nodes.$finalImageBase = $('.mix-and-match--item--base--image', self.nodes.$baseChoiceContainer);
    self.nodes.$finalImageOption = $('.mix-and-match--item--option--image', self.nodes.$optionChoiceContainer);
    self.nodes.$baseSubtitle = $('.mix-and-match--item--final--subtitle', self.nodes.$baseChoiceContainer);
    self.nodes.$optionSubtitle = $('.mix-and-match--item--final--subtitle', self.nodes.$optionChoiceContainer);
    self.nodes.$baseDetails = $('.mix-and-match--item--final--text', self.nodes.$baseChoiceContainer);
    self.nodes.$optionDetails = $('.mix-and-match--item--final--text', self.nodes.$optionChoiceContainer);
    self.nodes.$finalBreadcrumbImages = $('.mix-and-match--item--final--choices img', self.nodes.$formatter);
    self.nodes.editorialContainer = $('.js-mix-and-match--editorial', self.nodes.$formatter);
    self.nodes.$editorialStepsDescriptions = $('.mix-and-match--editorial--description p', self.nodes.editorialContainer);
    self.moduleImageFolder = self.nodes.$formatter.data('imagesFolder');
    self.moduleDefaultImage = self.nodes.$formatter.data('final-default-image');
    self.enableStep1Carousel;
    self.enableStep2Carousel;
    self.enableBothCarousels;
    self.disableBothCarousels;
  },

  setTemplateSettings: function (context) {
    var self = this;

    self.enableGridView = $('.mix-and-match--grid-view', context).length > 0;
    if (self.enableGridView) {
      // Set flags for carousels
      self.enableStep1Carousel = self.nodes.$stepSliderBase.data('isCarousel') && !self.nodes.$stepSliderOption.data('isCarousel');
      self.enableStep2Carousel = !self.nodes.$stepSliderBase.data('isCarousel') && self.nodes.$stepSliderOption.data('isCarousel');

      // If it's mobile, enable both carousels by default
      self.enableBothCarousels = site.client.isMobile ? true : self.nodes.$stepSliderBase.data('isCarousel') && self.nodes.$stepSliderOption.data('isCarousel');
      self.disableBothCarousels = site.client.isMobile ? false : !self.nodes.$stepSliderBase.data('isCarousel') && !self.nodes.$stepSliderOption.data('isCarousel');

      self.selectedSteps = 0;
    }
  },

  prepareHtml: function () {
    var self = this;

    if (self.enableGridView) {
      self.nodes.$detailsText.removeClass('hidden');
      self.nodes.$detailsButtons.addClass('hidden');
      self.nodes.$slickDotsContainerSteps.removeClass('hidden');
      self.nodes.$itemTitle.addClass('hidden');
      self.nodes.$itemTitleGridView.removeClass('hidden');
      self.nodes.$finalItem.addClass('disabled');

      var $imagesContainer = "<div class='mix-and-match--item--image--container js-mix-and-match--item--image--container'></div>";

      $(self.nodes.$baseItems).each(function () {
        $('img, .js-mix-and-match--item--tick', this).wrapAll($imagesContainer);
      });

      $(self.nodes.$optionItems).each(function () {
        $('img, .js-mix-and-match--item--tick', this).wrapAll($imagesContainer);
      });
    }
    if (!site.client.isMobile && self.enableGridView) {
      self.nodes.$itemWrapper.addClass('container-padding');
      self.nodes.$formatter.removeClass('hidden');
    }
    if (site.client.isMobile) {
      self.nodes.$editorialStepsDescriptions.addClass('hidden');
      self.nodes.$itemsImages.addClass('hidden');
      self.nodes.$finalImageBase.addClass('hidden');
      self.nodes.$finalImageOption.addClass('hidden');
      self.nodes.$finalRadioSection.remove();
      self.nodes.$baseFinalItemsChange.removeClass('hidden');
      self.nodes.$optionFinalItemsChange.removeClass('hidden');
      self.nodes.$changeMobile.removeClass('hidden');

      if (!self.enableGridView) {
        self.nodes.$addToBagButton.addClass('hidden');
        self.nodes.$finalItemContainer.append(self.nodes.$addToBagButton);
      }
    }

    self.nodes.$productImages.removeClass('hidden');
    self.preAppendImages(self.nodes.$baseItems);
    self.preAppendImages(self.nodes.$optionItems);
  },

  preAppendImages: function ($items) {
    var self = this;

    if ($items.length < 1) {
      return;
    }
    $items.first().addClass('first');
    $items.last().addClass('last');
    $items.map(function (i, option) {
      self.appendImages($(option));
    });
  },

  appendImages: function ($node) {
    var self = this;
    var $nodeImage = $node.find(self.nodes.$productImages);
    var productImagePath = self.moduleImageFolder + '/product_images/';
    var overlatImagePath = self.moduleImageFolder + '/overlay/';
    var productSkuBaseId = $node.data('sku').replace('SKU', '');
    var productImage = productSkuBaseId + '.jpg';

    productImage = productImagePath + productImage;

    var productAltImage = productImagePath + productSkuBaseId + '_altimage_1.jpg';

    // only set the images from product if they're not set in CMS
    if (!$nodeImage.data('src')) {
      $nodeImage.attr('src', productImage);
    }
    if (!$nodeImage.attr('data-src-image')) {
      $nodeImage.attr('data-src-image', productImage);
    }
    if (!$nodeImage.attr('data-alt-image')) {
      $nodeImage.attr('data-alt-image', productAltImage);
    }

    // firefox hack it doesnt load the image set as background from here. Do not remove tmpImage
    var tmpImage = $('<img />', { src: overlatImagePath + productSkuBaseId + '.jpg' });

    $node.find(self.nodes.$detailsContainers).css({ 'background-image': 'url(' + overlatImagePath + productSkuBaseId + '.jpg' + ')' });
  },

  loadFormatterSlick: function () {
    var self = this;
    var hideArrows = self.nodes.$formatter.data('hideNavigationArrows') || false;
    // Check site direction
    var pageDirection = self.nodes.$slider.closest('html').attr('dir');
    var slickRtl = pageDirection === 'rtl';

    self.nodes.$slider.slick({
      rtl: slickRtl,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: self.nodes.$formatter.data('sliderSpeed') ? self.nodes.$formatter.data('sliderSpeed') : 1500,
      dots: false,
      arrows: !hideArrows,
      centerMode: false,
      variableWidth: false,
      swipe: false
    });
    if (!hideArrows && !site.client.isMobile) {
      self.nodes.$slickNextArrow = self.nodes.$formatter.find('.slick-next');
      self.disableNextStep('1');
    }
  },

  loadStepsSlick: function () {
    var self = this;
    var $sliderSteps;
    var pageDirection = self.nodes.$slider.closest('html').attr('dir');
    var slickRtl = pageDirection === 'rtl';
    var infinite = false;
    var slidesToShow = 1;

    if (self.enableGridView && !self.disableBothCarousels) {
      $sliderSteps = site.client.isMobile ? self.nodes.$stepSliders.filter('[data-is-carousel]') : self.nodes.$stepSliders.filter('[data-is-carousel=1]');
      infinite = true;
      slidesToShow = site.client.isMobile ? slidesToShow : 3;
    } else {
      $sliderSteps = self.nodes.$stepSliders;
      $sliderSteps.last().on('init', function () {
        // after the last step individual slider has been loaded we can
        // load the formatter slider as well.
        self.loadFormatterSlick();
      });
    }

    $sliderSteps.each(function () {
      $(this).slick({
        rtl: slickRtl,
        infinite: infinite,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        speed: self.nodes.$formatter.data('stepsSliderSpeed') ? self.nodes.$formatter.data('stepsSliderSpeed') : 1500,
        dots: false
      });
    });
  },

  showItems: function () {
    var self = this;

    !self.enableGridView ? self.nodes.$selectButtons.html(self.nodes.$formatter.data('selectText')) : $('.js-mix-and-match--select--btn-text', self.nodes.$selectButtons).addClass('underlined').html(self.nodes.$formatter.data('selectText'));
    self.processItemsHtml(self.nodes.$baseItemsContainer, self.nodes.$baseItems);
    self.processItemsHtml(self.nodes.$optionItemsContainer, self.nodes.$optionItems);
  },
  processItemsHtml: function ($container, $items) {
    var self = this;

    // we have to query each step individualy to append the items, we can't use
    // the saved step sliders from the nodes
    $container.find('.js-mix-and-match--step--slider').append($items);
    self.checkAvailability($items);
    self.setFinalStepOptions($items);
  },

  checkAvailability: function ($nodes) {
    $nodes.each(function () {
      var $node = $(this);

      if ($node.data('inventoryStatus') && $node.data('inventoryStatus') === 1) {
        $node.removeClass('disabled').removeClass('unavailable');
      } else {
        $node.find('.js-mix-and-match--select--btn').addClass('hidden');
        $node.find('.js-mix-and-match--select--btn-text').addClass('hidden');
        $node.addClass('unavailable');
      }
    });
  },

  // Show the radio buttons in the final step
  // check inventoryStatus before create a radio button element for a sku
  setFinalStepOptions: function ($nodes) {
    var itemType;
    var radioOptionTitle;
    var skuId;
    var radioColor;
    var self = this;

    $($nodes).each(function () {
      var $node = $(this);

      itemType = $node.data('type');
      skuId = $node.data('skubaseid');
      radioColor = $node.data('final-step-radio-color');
      radioOptionTitle = '';
      if (!site.client.isMobile) {
        radioOptionTitle = $node.find('.js-mix-and-match--item--title').text();
      }
      var radioOptions = $('<input />', {
        type: 'radio',
        name: itemType + 'Items',
        id: itemType + skuId,
        'data-skubaseid': skuId,
        'disabled': 'disabled'
      });
      var radioInnerBGColor = $('<span />', {
        class: 'afterCheckmark'
      });
      var radioOuterBGColor = $('<span />', {
        class: 'checkmark',
        style: 'background-color: ' + radioColor,
        append: [radioInnerBGColor]
      });
      var radioLineItem = $('<span />', {
        append: [radioOptions, radioOptionTitle, radioOuterBGColor],
        class: 'mix-and-match--item--final--' + itemType + '--option js-mix-and-match--final--change--selection',
        'data-type': itemType
      });

      if (itemType === 'base') {
        self.nodes.$baseFinalItemsChange.append(radioLineItem);
      } else {
        self.nodes.$optionFinalItemsChange.append(radioLineItem);
      }
    });
  },

  setFinalStepDetails: function (type, $parent) {
    var self = this;

    if (type === 'base') {
      self.nodes.$baseSubtitle.html($parent.data('finalStepTitle'));
      self.nodes.$baseDetails.html($parent.data('finalStepDetails'));
      self.setSelectedBreadcrumbIcon('final-base', $parent.data('skubaseid'), true);
    } else {
      self.nodes.$optionSubtitle.html($parent.data('finalStepTitle'));
      self.nodes.$optionDetails.html($parent.data('finalStepDetails'));
      self.setSelectedBreadcrumbIcon('final-option', $parent.data('skubaseid'), true);
    }
  },

  scrollPageToNextStep: function (type) {
    var self = this;

    type === 'base' ? self.nodes.$optionItemsContainer[0].scrollIntoView({ behavior: 'smooth' }) : self.nodes.$finalItem[0].scrollIntoView({ behavior: 'smooth' });
  },

  // On mobile, when click the 'change' link, scroll to parent section
  scrollPageToParentStep: function (type) {
    var self = this;

    type === 'base' ? self.nodes.$baseItemsContainer[0].scrollIntoView({ behavior: 'smooth' }) : self.nodes.$optionItemsContainer[0].scrollIntoView({ behavior: 'smooth' });
  },

  ctaGridViewEvents: function (type, $parent, sliderIndex) {
    var self = this;
    var $currentSelectButton = $('.js-mix-and-match--select--btn .js-mix-and-match--select--btn-text', $parent);
    var $imageContainer = $('.js-mix-and-match--item--image--container', $parent);
    var $tickImage = $('.js-mix-and-match--item--tick', $parent);

    self.removePreviousSelections(type);

    if (!$currentSelectButton.hasClass('selected-item')) {
      $currentSelectButton.addClass('selected-item');
      $imageContainer.addClass('mix-and-match--item--selected');
      $tickImage.removeClass('hidden');
      $currentSelectButton.html(self.nodes.$formatter.data('deselectText'));
      self.setParentState($parent, self.nodes.$baseItems);

      // Breadcrumbs
      self.setSelectedBreadcrumbIcon(type, $parent.data('skubaseid'), true);
      self.nodes.$slickDots.filter('[data-slider-index=' + sliderIndex + ']').removeClass('active');
      self.nodes.$slickDots.filter('[data-slider-index=' + parseInt(sliderIndex + 1) + ']').addClass('active').addClass('loaded');

      $parent.parents('.js-mix-and-match--item-' + type + '--wrapper').find('.js-mix-and-match--select--btn-text').not($currentSelectButton).removeClass('selected-item');

      self.setFinalStepDetails(type, $parent);

      var $addToBagButton = self.nodes.$addToBagButton;

      if ($addToBagButton.attr('data-skubaseid') && $addToBagButton.data('secondary-sku-base-id')) {
        self.nodes.$finalItem.removeClass('disabled');
        $addToBagButton.removeClass('disabled');
        self.nodes.$learnMore.removeClass('disabled');
        if (!site.client.isMobile) {
          $('input:radio', self.nodes.$finalRadioSection).prop('disabled', false);
        }
        self.prepareFinalStep();
      }
      self.scrollPageToNextStep(type);
    } else {
      $currentSelectButton.removeClass('selected-item');
      self.nodes.$slickDots.removeClass('active');
      self.nodes.$slickDots.filter('[data-slider-index=' + sliderIndex + ']').addClass('active').addClass('loaded');
      var contextSelection = self.nodes.$baseFinalItemsChange;

      if (type === 'option') {
        contextSelection = self.nodes.$optionFinalItemsChange;
      }
      self.toggleRadioButtonColor(contextSelection);
      self.nodes.$finalImage.attr('src', self.moduleDefaultImage);
    }
  },

  addEvents: function () {
    var self = this;

    self.nodes.$baseImagesContainer = $('.js-mix-and-match--item--image--container', self.nodes.$baseItemsContainer);
    self.nodes.$optionImagesContainer = $('.js-mix-and-match--item--image--container', self.nodes.$optionItemsContainer);
    // handle select button click on first step
    self.nodes.$baseItems.find(self.nodes.$selectButtons).add(self.nodes.$baseImagesContainer).on('click', function (e) {
      e.preventDefault();

      if (!self.enableGridView) {
        self.resetSelection();
      }

      var $parent = $(this).closest(self.nodes.$baseItems);

      self.toggleRadioButtonColor(self.nodes.$baseFinalItemsChange);
      self.selectSteps($parent);
    });

    // handle select button click on second step
    self.nodes.$optionItems.find(self.nodes.$selectButtons).add(self.nodes.$optionImagesContainer).on('click', function () {
      var $parent = $(this).closest(self.nodes.$optionItems);

      self.toggleRadioButtonColor(self.nodes.$optionFinalItemsChange);
      self.selectSteps($parent);
    });

    // Handle radio button click event
    var $finalSelectionChange = $('.js-mix-and-match--final--change--selection', self.nodes.$finalItem);

    $finalSelectionChange.on('click', function () {
      var skuInput = $(this).find(':input');
      var type = $(this).data('type');
      var disProperty = skuInput.attr('disabled');
      var skubaseid = skuInput.data('skubaseid');
      var contextSelection = self.nodes.$baseFinalItemsChange;
      var contextContainer = self.nodes.$baseItemsContainer;

      if (!(typeof disProperty !== typeof undefined && disProperty !== false)) {
        if (type === 'option') {
          contextSelection = self.nodes.$optionFinalItemsChange;
          contextContainer = self.nodes.$optionItemsContainer;
        }
        self.toggleRadioButtonColor(contextSelection);
        var $stepNewParent = $('.js-mix-and-match--item-' + type + '[data-skubaseid="' + skubaseid + '"]', contextContainer);

        self.selectSteps($stepNewParent);
      }
    });

    // Handle details button click event
    self.nodes.$detailsButtons.on('click', function () {
      self.toggleDetailsOverlay($(this));
    });

    // handle details close button click event
    self.nodes.$detailsCloseButtons.on('click', function () {
      self.toggleDetailsOverlay($(this));
    });

    // Handle 'change' button click event - Mobile
    self.nodes.$changeMobile.on('click', function () {
      if (!self.nodes.$finalItem.hasClass('disabled')) {
        self.scrollPageToParentStep($(this).data('type'));
      }
    });

    // Handle 'Learn More' button click event
    self.nodes.$learnMore.on('click', function (e) {
      if ($(this).hasClass('disabled')) {
        e.preventDefault();
      }
    });

    // wait for the Slider to load in order to show the proper step 
    // and have the required elements in the right place on the page
    self.nodes.$slider.on('init', function () {
      if (!(self.enableStep1Carousel || self.enableStep2Carousel || self.enableBothCarousels)) {
        self.nodes.$formatter.removeClass('hidden');
        self.nodes.$slickDotsContainer.first().removeClass('hidden');
      }
      var sliderIndex;
      var stepSelectedIndex;

      self.nodes.$slickDots.each(function () {
        var $dot = $(this);

        $dot.off('click').on('click', function () {
          if ($dot.hasClass('loaded')) {
            sliderIndex = $dot.data('sliderIndex');
            self.nodes.$slider.slick('slickGoTo', sliderIndex);
            // if there is an active slick slider on the step the user scrolls to
            // we have to scroll that slider to the selected item as well
            if (self.nodes.$stepSliders.eq(sliderIndex).hasClass('slick-initialized')) {
              stepSelectedIndex = self.nodes.$stepSliders.eq(sliderIndex).find('.mix-and-match--item.selected').data('slickIndex');
              self.nodes.$stepSliders.eq(sliderIndex).slick('slickGoTo', stepSelectedIndex);
            }
          }
        });
      });
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      if (nextSlide === 2) {
        self.prepareFinalStep();
      }
      self.nodes.$slickDots.filter('[data-slider-index="' + currentSlide + '"]').removeClass('active');
      self.nodes.$slickDots.filter('[data-slider-index="' + nextSlide + '"]').addClass('active').addClass('loaded');
    }).on('afterChange', function (event, slick, currentSlide) {
      self.disableNextStep(currentSlide + 1);
    });

    self.nodes.$stepSliders.on('beforeChange', function (event) {
      // we have to stop the propagation to the wrapper slider
      // it's a known issue on nested sliders
      event.stopPropagation();
    });
    $(document).on('addToCartKitItem.success', function () {
      // add time out so the user has 1 sec to see the cart confirmation popup
      setTimeout(function () {
        self.resetSelection();
      }, 1000);
    });

    if (self.enableGridView) {
      $('.js-mix-and-match--item--image--container', '.mix-and-match--step--slider').hover(function () {
        var $context = this;
        var $itemImage = $('.js-mix-and-match--item--image', $context);
        var $imageContainer = $itemImage.closest('.js-mix-and-match--item--image--container');

        $itemImage.animate({
          opacity: 0
        }, 300, function () {
          $itemImage.attr('src', '');
          $itemImage.attr('src', $itemImage.data('altImage'));
          $imageContainer.toggleClass('no-padding');
          $itemImage.toggleClass('image-fit-content');
          $itemImage.animate({
            opacity: 1
          }, 200);
        });
      }, function () {
        var $context = this;
        var $itemImage = $('.js-mix-and-match--item--image', $context);
        var $imageContainer = $itemImage.closest('.js-mix-and-match--item--image--container');

        $itemImage.animate({
          opacity: 0
        }, 100, function () {
          $itemImage.attr('src', '');
          $itemImage.attr('src', $itemImage.data('srcImage'));
          $imageContainer.toggleClass('no-padding');
          $itemImage.toggleClass('image-fit-content');
          $itemImage.animate({
            opacity: 1
          }, 200);
        });
      });
    }
  },

  toggleRadioButtonColor: function ($radioWrapper) {
    var $radioChecked = $radioWrapper.find('.checked');
    var bgColor = $radioChecked.css('background-color');
    var $radioCheckedParent;

    if (bgColor) {
      $radioCheckedParent = $radioChecked.parent();
      $radioChecked.css({ 'background-color': '' });
      $radioCheckedParent.css({ 'background-color': bgColor });
      $radioCheckedParent.removeClass('circleRadio');
      $radioWrapper.find('.afterCheckmark').removeClass('checked');
    }
  },

  // Select steps for base & options items
  selectSteps: function ($parent) {
    var self = this;
    var skuBaseId = $parent.data('skubaseid');
    var type = $parent.data('type');
    var contextSource = self.nodes.$baseItems;
    var skuDataAttr = 'data-skubaseid';
    var skuAttr = 'skubaseid';
    var radioContextSource = self.nodes.$baseFinalItemsChange;
    var delta = 0;

    if (type === 'option') {
      contextSource = self.nodes.$optionItems;
      skuDataAttr = 'data-secondary-sku-base-id';
      skuAttr = 'secondarySkuBaseId';
      radioContextSource = self.nodes.$optionFinalItemsChange;
      delta = 1;
    }
    self.setParentState($parent, contextSource);
    self.setSelectedBreadcrumbIcon(type, skuBaseId, true);
    self.nodes.$addToBagButton.attr(skuDataAttr, skuBaseId).data(skuAttr, skuBaseId);
    var $radioSection = radioContextSource.find('[data-skubaseid="' + skuBaseId + '"]');

    if ($radioSection) {
      var $radioCircleColor = $radioSection.next();

      $radioSection.prop('checked', true);
      $radioCircleColor.addClass('circleRadio');
      $radioCircleColor.css({ 'background-color': '' });
      $radioCircleColor.find('.afterCheckmark').addClass('checked').css({ 'background-color': $parent.data('final-step-radio-color') });
      self.nodes.$learnMore.attr('href', $parent.data('spp-url'));
    }
    if (self.enableGridView) {
      self.ctaGridViewEvents(type, $parent, delta);
    } else {
      if (type === 'option') {
        self.nodes.$addToBagButton.removeClass('disabled');
      }
      self.nodes.$slider.slick('slickGoTo', delta + 1);
    }
  },

  disableNextStep: function (nextSlide) {
    var self = this;

    if (typeof self.nodes.$slickNextArrow === 'undefined') {
      return;
    }
    var nextDot = self.nodes.$slickDots.filter('[data-slider-index="' + nextSlide + '"]');

    self.nodes.$slickNextArrow.prop('disabled', false);
    if (nextDot.length && !nextDot.hasClass('loaded')) {
      self.nodes.$slickNextArrow.addClass('slick-disabled');
      self.nodes.$slickNextArrow.prop('disabled', true);
    }
  },

  setSelectedBreadcrumbIcon: function (type, skuId, select) {
    var self = this;
    var newBreadcrumb = self.moduleImageFolder + '/breadcrumbs/' + skuId + '.png';
    var $breadcrumb = self.nodes.$slickDots.filter('[data-type="' + type + '"]').length !== 0 ? self.nodes.$slickDots.filter('[data-type="' + type + '"]') : self.nodes.$finalBreadcrumbImages.filter('[data-type="' + type + '"]');

    $breadcrumb.attr('src', newBreadcrumb);
    if (select) {
      $breadcrumb.addClass('selected').addClass('loaded');
    } else {
      $breadcrumb.removeClass('selected').removeClass('loaded');
    }
  },

  setParentState: function ($parent, $nodes) {
    var self = this;

    // check if the details overlay has been opened and never closed
    // the toggleClasses was triggered already we don't have to retriger it
    if (!$parent.hasClass('selected')) {
      self.toggleClasses($nodes, $parent, true);
    }
    self.nodes.$detailsContainers.addClass('hidden');
  },

  toggleDetailsOverlay: function ($elem) {
    var self = this;

    if ($elem.data('stepType') !== 'final') {
      var $parentItemContainer = $elem.closest(self.nodes.$baseItems);
      var $parentNodes = self.nodes.$baseItems;

      if (!$parentItemContainer.length) {
        $parentItemContainer = $elem.closest(self.nodes.$optionItems);
        $parentNodes = self.nodes.$optionItems;
      }
      if ($parentItemContainer.hasClass('unavailable')) {
        return true;
      }
      var $detailsContainer = $parentItemContainer.find(self.nodes.$detailsContainers);

      self.nodes.$detailsContainers.not($detailsContainer).addClass('hidden');
      $detailsContainer.toggleClass('hidden');

      self.toggleClasses($parentNodes, $parentItemContainer, false);
    } else {
      self.nodes.$finalDetailsContainer.toggleClass('hidden');
    }
  },

  getFinalPrice: function ($optionNode, $baseNode) {
    var settings = Drupal.settings.globals_variables || {};
    var show_comma_separated_price = settings.comma_seperated_price !== 'undefined' ? settings.comma_seperated_price : 0;

    if (show_comma_separated_price) {
      finalPrice = $optionNode.data('price') + $baseNode.data('price');

      return $optionNode.data('formattedPrice').replace($optionNode.data('price').toLocaleString('en'), finalPrice.toLocaleString('en'));
    }
    if (typeof site.sellsWith.getPriceFormat !== 'function') {
      return $optionNode.data('formattedPrice');
    }
    var priceFormat = site.sellsWith.getPriceFormat($optionNode.data('formattedPrice'));
    var originalPrice = site.sellsWith.formatPrice($optionNode.data('price'), priceFormat);
    var finalPrice = site.sellsWith.formatPrice($optionNode.data('price') + $baseNode.data('price'), priceFormat);

    return $optionNode.data('formattedPrice').replace(originalPrice, finalPrice);
  },

  prepareFinalStep: function () {
    var self = this;
    var finalPriceComponents = self.nodes.$formatter.data('finalPriceComponents') || 'both';
    var skusSelectedString = self.nodes.$addToBagButton.data('skubaseid') + '_' + self.nodes.$optionItems.filter('.selected').data('skubaseid');
    var finalImagesrc = self.moduleImageFolder + '/product_images/' + skusSelectedString + '.jpg';
    var finalDetailsOverlayBg = self.moduleImageFolder + '/overlay/' + skusSelectedString + '.jpg';
    var $baseNode = self.nodes.$baseItems.filter('.selected');
    var $optionNode = self.nodes.$optionItems.filter('.selected');
    var finalTitle = $baseNode.data('finalStepTitle') + $optionNode.data('finalStepTitle');
    var finalDetailsText = $baseNode.data('finalStepDetails') + $optionNode.data('finalStepDetails');
    var finalDetailsColor = $optionNode.data('finalStepDetailsColor');
    var finalItemPrice = finalPriceComponents !== 'hide' ? $optionNode.data('formattedPrice') : '';

    if (finalPriceComponents === 'both') {
      finalItemPrice = self.getFinalPrice($optionNode, $baseNode);
    } else if (finalPriceComponents === 'base') {
      finalItemPrice = $baseNode.data('formattedPrice');
    } else if (finalPriceComponents === 'combined') {
      finalItemPrice = $optionNode.data('cartridgePrice');
    }

    self.setSelectedBreadcrumbIcon('final', skusSelectedString, true);
    self.initAddToBag();
    self.nodes.$finalImage.attr('src', finalImagesrc);
    if (!self.enableGridView) {
      self.nodes.$finalTitle.html(finalTitle);
    }
    self.nodes.$finalItemPriceContainer.html(finalItemPrice);
    self.nodes.$finalDetailsContainer.css({ 'background-image': 'url(' + finalDetailsOverlayBg + ')' })
      .find('.mix-and-match--item--final--details--text').html(finalDetailsText);
    if (finalDetailsColor) {
      self.nodes.$finalDetailsContainer.css({ 'color': finalDetailsColor });
    } else {
      self.nodes.$finalDetailsContainer.css({ 'color': '' });
    }
  },

  initAddToBag: function () {
    var self = this;

    if (self.nodes.$addToBagButton.hasClass('disabled') || self.nodes.$addToBagButton.hasClass('follow-link')) {
      return true;
    }
    site.quickshop.initAddToBag(self.nodes.$addToBagButton, self.nodes.$addToBagButton.attr('data-skubaseid'));
  },

  toggleClasses: function ($nodes, $current, select) {
    var self = this;
    var checkHighlight = false;

    if (!self.enableGridView && (select || !site.client.isMobile && !$current.hasClass('highlight'))) {
      checkHighlight = true;
    }
    if (!$current.hasClass('selected') && checkHighlight) {
      $nodes.not($current).addClass('disabled');
      if (select) {
        $nodes.not($current).removeClass('selected');
      }
      $current.removeClass('disabled');
    } else if (!select && $nodes.not($current).hasClass('selected')) {
      // if the toggle is called from the details buttons, we have to check 
      // if there was no item selected once
      if ($nodes.not($current).hasClass('selected')) {
        $nodes.not($current).filter('.selected').removeClass('disabled');
        $current.addClass('disabled');
      } else {
        $nodes.not($current).removeClass('disabled');
      }
    } else if (!$current.hasClass('selected')) {
      $nodes.not($current).removeClass('disabled');
    }
    $nodes.not($current).removeClass('highlight');
    if (select) {
      $current.toggleClass('selected');
    }
    if (!site.client.isMobile) {
      // we only highlight if it's not mobile, on mobile there's only 1
      // product showing we don't have to highlight
      $current.toggleClass('highlight');
    }
  },

  clearSelection: function ($nodes, clearAttr) {
    var self = this;

    $nodes.removeClass('selected').removeClass('highlight').removeClass('disabled');
    self.nodes.$addToBagButton.removeAttr(clearAttr);
  },

  removePreviousSelections: function (type) {
    var self = this;
    var $parent;
    var $breadcrumb = self.nodes.$slickDots.filter('[data-type="' + type + '"]').length !== 0 ? self.nodes.$slickDots.filter('[data-type="' + type + '"]') : self.nodes.$finalBreadcrumbImages.filter('[data-type="' + type + '"]');
    var $finalBreadcrumb = self.nodes.$slickDots.filter('[data-type="final"]').length !== 0 ? self.nodes.$slickDots.filter('[data-type="final"]') : self.nodes.$finalBreadcrumbImages.filter('[data-type="final"]');

    if (type === 'base') {
      $parent = self.nodes.$baseItemsContainer;
      self.nodes.$baseSubtitle.html($parent.data('defaultBaseSubtitle'));
      self.nodes.$baseDetails.html($parent.data('defaultBaseText'));
      self.nodes.$finalImageBase.attr('src', self.nodes.$baseItemsContainer.data('baseBreadcrumb'));
      $breadcrumb.attr('src', self.nodes.$baseItemsContainer.data('baseBreadcrumb'));
    } else if (type === 'option') {
      $parent = self.nodes.$optionItemsContainer;
      self.nodes.$optionSubtitle.html($parent.data('defaultOptionSubtitle'));
      self.nodes.$optionDetails.html($parent.data('defaultOptionText'));
      self.nodes.$finalImageOption.attr('src', self.nodes.$optionItemsContainer.data('optionBreadcrumb'));
      $breadcrumb.attr('src', self.nodes.$optionItemsContainer.data('optionBreadcrumb'));
      self.nodes.$optionItems.removeClass('selected');
    }
    $finalBreadcrumb.attr('src', self.nodes.$finalItem.data('finalBreadcrumb'));

    $('.js-mix-and-match--select--btn .js-mix-and-match--select--btn-text', $parent).html(self.nodes.$formatter.data('selectText'));
    $('.js-mix-and-match--item--image--container', $parent).removeClass('mix-and-match--item--selected');
    $('.js-mix-and-match--item--tick', $parent).addClass('hidden');

    if (self.selectedSteps > 1) {
      self.selectedSteps -= 1;
      if (type === 'base') {
        self.nodes.$addToBagButton.removeAttr('data-skubaseid');
      } else if (type === 'option') {
        self.nodes.$addToBagButton.removeAttr('data-secondary-sku-base-id');
      }
      $('input:radio', self.nodes.$finalRadioSection).prop('disabled', true);
      self.nodes.$learnMore.addClass('disabled');
      self.nodes.$finalItem.addClass('disabled');
      self.nodes.$addToBagButton.addClass('disabled').unbind();
    }
    self.nodes.$finalItemPriceContainer.html(self.nodes.$finalItemPriceContainer.data('defaultPrice'));
  },

  resetSelection: function () {
    var self = this;

    self.clearSelection(self.nodes.$baseItems, 'data-skubaseid');
    self.clearSelection(self.nodes.$optionItems, 'data-secondary-sku-base-id');
    self.nodes.$addToBagButton.addClass('disabled');

    self.nodes.$slickDots.filter('[data-type!="base"]').each(function (i, el) {
      self.setSelectedBreadcrumbIcon($(el).data('type'), $(el).data('slider-index') + 1, false);
    });
    if (site.client.isMobile) {
      // we have to scroll second step slider to 0 if we are on mobile
      self.nodes.$stepSliders.eq(1).slick('slickGoTo', 0);
    }

    // this happens when the reset comes from last step, after the add to bag was successful
    if (typeof self.nodes.$slider[0].slick !== 'undefined' && self.nodes.$slider[0].slick.currentSlide !== 0) {
      if (site.client.isMobile) {
        self.nodes.$stepSliders.eq(0).slick('slickGoTo', 0);
      }
      self.nodes.$slider.slick('slickGoTo', 0);
      self.setSelectedBreadcrumbIcon('base', 1, false);
    }
  },

  init: function (context) {
    var self = this;

    self.getDom(context);
    self.setTemplateSettings(context);

    self.prepareHtml();
    self.showItems();
    self.addEvents();

    if (!site.client.isMobile && !self.enableGridView) {
      self.loadFormatterSlick();
    } else if (site.client.isMobile || (self.enableStep1Carousel || self.enableStep2Carousel || self.enableBothCarousels)) {
      self.nodes.$formatter.removeClass('hidden');
      self.loadStepsSlick();
    }

    if (!self.enableGridView) {
      self.nodes.$baseImagesContainer.off('click');
      self.nodes.$optionImagesContainer.off('click');
    }
  }
};
(function () {
  Drupal.behaviors.mixAndMatchFormatterV1 = {
    attach: function (context) {
      site.MixAndMatch = new mixAndMatch(context);
    }
  };
})();
